if (!window.reaRecentlyViewedInit) {
  window.reaRecentlyViewedInit = true;

  const STORAGE_KEY = 'rea:recentlyViewed';
  const MAX_STORED = 12;

  const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[char]));

  const readStored = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  };

  const writeStored = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Storage unavailable (private mode, quota) — fail silently, no list renders.
    }
  };

  const recordSelf = () => {
    const selfDataEl = document.querySelector('[data-recently-viewed-self]');
    if (!selfDataEl) return null;

    let self;
    try {
      self = JSON.parse(selfDataEl.textContent);
    } catch (error) {
      return null;
    }

    const items = readStored().filter((item) => item.handle !== self.handle);
    items.unshift(self);
    writeStored(items.slice(0, MAX_STORED));
    return self.handle;
  };

  const buildCard = (item) => {
    const li = document.createElement('li');
    li.className = 'rea-recently-viewed__item';

    const link = document.createElement('a');
    link.className = 'rea-recently-viewed__link';
    link.href = item.url;

    const media = document.createElement('span');
    media.className = 'rea-recently-viewed__media';
    // Matches card-product.liquid's own "adapt" ratio (the product's real
    // media aspect ratio, not a fixed crop) - falls back to a reasonable
    // portrait default only for entries cached before imageWidth/imageHeight
    // existed in the stored payload.
    media.style.aspectRatio = item.imageWidth && item.imageHeight ? `${item.imageWidth} / ${item.imageHeight}` : '3 / 4';
    if (item.image) {
      const img = document.createElement('img');
      // Matches card-product.liquid's own breakpoint-based sizing (23vw
      // desktop 4-col slot, 45vw mobile carousel slide) instead of always
      // fetching one flat 400px image regardless of the rendered size.
      if (Array.isArray(item.sources) && item.sources.length) {
        img.srcset = item.sources.map((source) => `${source.url} ${source.width}w`).join(', ');
        img.sizes = '(min-width: 750px) 23vw, 45vw';
      }
      img.src = item.image;
      img.alt = item.title;
      img.loading = 'lazy';
      img.width = item.imageWidth || 400;
      img.height = item.imageHeight || 400;
      media.appendChild(img);
    }

    const title = document.createElement('span');
    title.className = 'rea-recently-viewed__title';
    title.textContent = item.title;

    // Reuses component-price.css's own classes/structure (price.liquid),
    // rather than the old bespoke flat-text span, so a discounted product
    // reads identically here as it does in "You may also like".
    const price = document.createElement('div');
    const onSale = !!item.compareAtPrice;
    price.className = `price${onSale ? ' price--on-sale' : ''}`;
    price.innerHTML = `
      <div class="price__container">
        ${
          onSale
            ? `<div class="price__sale">
                <span><s class="price-item price-item--regular">${escapeHtml(item.compareAtPrice)}</s></span>
                <span class="price-item price-item--sale price-item--last">${escapeHtml(item.price)}</span>
              </div>`
            : `<div class="price__regular">
                <span class="price-item price-item--regular">${escapeHtml(item.price)}</span>
              </div>`
        }
      </div>
    `;

    link.append(media, title, price);
    li.appendChild(link);
    return li;
  };

  const updateSliderControls = (container, list) => {
    const buttons = container.querySelector('[data-recently-viewed-buttons]');
    const prev = container.querySelector('[data-recently-viewed-prev]');
    const next = container.querySelector('[data-recently-viewed-next]');
    const currentEl = container.querySelector('[data-recently-viewed-current]');
    const totalEl = container.querySelector('[data-recently-viewed-total]');
    if (!buttons || !prev || !next || !currentEl || !totalEl) return;

    const total = list.children.length;
    totalEl.textContent = total;

    if (total <= 1) {
      buttons.classList.add('hidden');
      return;
    }
    buttons.classList.remove('hidden');

    const updateCurrent = () => {
      const maxScroll = list.scrollWidth - list.clientWidth;
      const index = maxScroll > 0 ? Math.round((list.scrollLeft / maxScroll) * (total - 1)) : 0;
      currentEl.textContent = index + 1;
    };

    const scrollByOne = (direction) => {
      const item = list.children[0];
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      const distance = (item.getBoundingClientRect().width + gap) * direction;
      list.scrollBy({ left: distance, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByOne(-1));
    next.addEventListener('click', () => scrollByOne(1));
    list.addEventListener('scroll', updateCurrent, { passive: true });
    updateCurrent();
  };

  const renderInto = (container, currentHandle) => {
    const list = container.querySelector('.rea-recently-viewed__list');
    if (!list) return;

    const limit = parseInt(container.dataset.limit, 10) || 4;
    const items = readStored()
      .filter((item) => item.handle !== currentHandle)
      .slice(0, limit);

    if (items.length === 0) return;

    items.forEach((item) => list.appendChild(buildCard(item)));
    container.classList.remove('hidden');
    updateSliderControls(container, list);
  };

  const currentHandle = recordSelf();
  document.querySelectorAll('[data-recently-viewed]').forEach((container) => {
    renderInto(container, currentHandle);
  });
}
